import { render, staticRenderFns } from "./journey.vue?vue&type=template&id=800a1470&scoped=true"
import script from "./journey.vue?vue&type=script&lang=js"
export * from "./journey.vue?vue&type=script&lang=js"
import style0 from "./journey.vue?vue&type=style&index=0&id=800a1470&prod&lang=css"
import style1 from "./journey.vue?vue&type=style&index=1&id=800a1470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800a1470",
  null
  
)

export default component.exports